/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import styles from './Style/IconTool.module.scss';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import { StoreContext } from '../../store/store';
import LegendView from '../Home/Component/LegendView';

export interface IconToolProps {
  // isMark: boolean;
  onCollapse: (bool: boolean) => void;
  // onMark: (bool: boolean) => void;
  collapseOpen: boolean;
}

export default function IconTool(props: IconToolProps) {
  const { legend } = useContext(StoreContext);
  // const [isEdit, setIsEdit] = useState<boolean>(false);

  /* function onAddLocation() {
    const temp = !props.isMark;
    // setIsEdit(temp);
    props.onMark(temp);
  } */

  function onCollapse() {
    props.onCollapse(!props.collapseOpen);
  }

  return (
    <div
      className={`${styles.root} ${props.collapseOpen ? '' : styles.rootOpen}`}
    >
      <IconBox
        className={`${styles.collapseBtn} ${
          props.collapseOpen ? '' : styles.collapseBtnOn
        }`}
        onClick={onCollapse}
      >
        {props.collapseOpen ? <LeftOutlined /> : <RightOutlined />}
      </IconBox>
      {legend.display && <LegendView />}
    </div>
  );
}

export function IconBox(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >
) {
  return (
    <div
      style={props.style}
      className={`${styles.iconBox} ${props.className ? props.className : ''}`}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
}
